var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n                       .st0{fill:currentColor;}\r\n                   ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4,11.6h9.4c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H4c-0.3,0-0.6,0.3-0.6,0.6C3.3,11.4,3.6,11.6,4,11.6z                            "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.6,14.4H4c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h5.6c0.3,0,0.6-0.3,0.6-0.6S9.9,14.4,9.6,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.9,12.9V4c0-1.4-1.2-2.6-2.6-2.6h-2.1v-1c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5v1h-7v-1                            c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5v1H3.1C1.7,1.4,0.5,2.6,0.5,4v13.9c0,1.4,1.2,2.6,2.6,2.6h9.5c1,2.5,3.6,4,6.3,3.5                            c2.7-0.5,4.6-2.8,4.6-5.6C23.5,15.7,21.5,13.4,18.9,12.9z M3.1,2.4h2.1v1c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-1h7v1                            c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-1h2.1c0.9,0,1.5,0.7,1.5,1.5v1.2H1.5V4C1.5,3.1,2.2,2.4,3.1,2.4z M3.1,19.5                            c-0.9,0-1.5-0.7-1.5-1.5V6.3h16.3v6.5h0c-1.7,0-3.3,0.7-4.3,2c-1.1,1.3-1.5,3-1.2,4.6H3.1z M17.9,23c-2.6,0-4.6-2.1-4.6-4.6                            s2.1-4.6,4.6-4.6c2.6,0,4.6,2.1,4.6,4.6C22.5,21,20.4,23,17.9,23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.7,16.4l-3.6,3.5L15.3,18c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l2.3,2.3c0.1,0.1,0.3,0.2,0.4,0.2                            c0.2,0,0.3-0.1,0.4-0.2l4-3.9c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4C21.4,16.2,21,16.2,20.7,16.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/appointments.42e00d69fe5833124920c7b921dac360.svg";
export { ForwardRef as ReactComponent };